module.exports = "/static/assets/87c98d386b3f4423fc82ecec23ca4f16.png";